// @flow

import {
    postReportRequestParameters,
    getReportRequestParameters,
} from './server_side_structs';
import {getJSON, postData} from '../util/ajax';
import type Route from './route';
import {Common} from '../util/enums';
import {Event, ErrorEvent} from '../util/evented';
import {warnOnce} from '../util/util';

export default function getRouteReports(route: Route) {
    const options = route._options;
    if (!options.stops || options.stops.length < 2) {
        warnOnce('A route needs at least two stops');
        return;
    }
    if (!options.reportType || options.reportType.length === 0) {
        return;
    }

    const hasStopOptions = options.stops.some(
        (stop) => typeof stop.lngLat !== 'undefined'
    );

    let makeRequest;
    let reportRequestParameters;
    // using stop options requires POST
    if (options.requestMethod === Common.RequestMethod.POST || hasStopOptions) {
        makeRequest = postData;
        reportRequestParameters = postReportRequestParameters(
            route._routeId,
            options
        );
    } else {
        makeRequest = getJSON;
        reportRequestParameters = getReportRequestParameters(options);
    }
    /**
     * Fired when the report is loading.
     *
     * @event reportloading
     * @memberof Route
     * @instance
     * @type {Object}
     * @property {Event} report object that starts loading.
     */
    route.fire(new Event('reportloading'));
    // reports request
    makeRequest(reportRequestParameters, (error, data) => {
        if (error) {
            error.name = 'report';
            route.fire(new ErrorEvent(error));
        } else if (data) {
            if (
                options.requestMethod === Common.RequestMethod.POST ||
                hasStopOptions
            ) {
                data = JSON.parse(data);
            }
            /**
             * Fired when the report has been returned.
             *
             * @event report
             * @memberof Route
             * @instance
             * @type {Object}
             * @property {Event} report object that has been returned.
             */
            route.fire(new Event('report', data));
        }
    });
}
